import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';

export default function UnitEconomicsPage() {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState('');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await apiClient.get('/clients');
        setClients(data || []);
        if (Array.isArray(data) && data.length) {
          setSelectedClient(data[0].id);
        }
      } catch (err) {
        console.error('Не удалось загрузить клиентов:', err);
        setError('Ошибка загрузки клиентов');
      }
    })();
  }, []);

  useEffect(() => {
    if (!selectedClient) return;
    fetchReport(selectedClient);
  }, [selectedClient]);

  const fetchReport = async (clientId) => {
    setLoading(true);
    setError('');
    try {
      const response = await apiClient.get('/reports/unit-economics', {
        params: { client_id: clientId },
      });
      setData(response.data);
    } catch (err) {
      console.error('Ошибка отчета:', err);
      setError('Не удалось загрузить отчёт');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto p-6 space-y-6">
      <h2 className="text-2xl font-bold">Юнит-экономика и тепловая карта</h2>

      <div className="space-y-2">
        <label className="text-sm font-semibold">Выберите клиента Wildberries:</label>
        <select
          className="w-full border rounded px-3 py-2"
          value={selectedClient}
          onChange={(e) => setSelectedClient(e.target.value)}
        >
          <option value="">-- Нет выбранного клиента --</option>
          {clients.map((client) => (
            <option key={client.id} value={client.id}>
              {client.name || `Клиент ${client.id}`}
            </option>
          ))}
        </select>
      </div>

      {loading && <p className="text-sm text-gray-500">Загрузка отчета...</p>}
      {error && <p className="text-sm text-red-500">{error}</p>}
      {!loading && data && (
        <div className="space-y-4">
          <div className="bg-white border rounded p-4 grid grid-cols-3 gap-4">
            <div>
              <p className="text-sm text-gray-500">Суммарный доход</p>
              <p className="text-lg font-semibold">{data.summary?.totalRevenue?.toLocaleString()} ₽</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Прибыль</p>
              <p className="text-lg font-semibold">{data.summary?.totalProfit?.toLocaleString()} ₽</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Заказы</p>
              <p className="text-lg font-semibold">{data.summary?.totalOrders}</p>
            </div>
          </div>

          <div className="bg-white border rounded p-4">
            <h3 className="font-semibold mb-3">Список артикулов</h3>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-gray-500">
                    <th className="py-2">Артикул</th>
                    <th className="py-2">Доход</th>
                    <th className="py-2">Прибыль</th>
                    <th className="py-2">Заказы</th>
                  </tr>
                </thead>
                <tbody>
                  {data.items?.map((item) => (
                    <tr key={item.id} className="border-t">
                      <td className="py-2">{item.article}</td>
                      <td className="py-2">{(item.metrics?.revenue || 0).toLocaleString()} ₽</td>
                      <td className="py-2">{(item.metrics?.profit || 0).toLocaleString()} ₽</td>
                      <td className="py-2">{item.metrics?.orders || 0}</td>
                    </tr>
                  ))}
                  {!data.items?.length && (
                    <tr>
                      <td className="py-2" colSpan={4}>Нет данных</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
